export default __webpack_public_path__ + "static/media/LogoKnockit.2de0bcda.png";